import { render } from "./clipboard-data.vue?vue&type=template&id=1b9a9beb"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/clipboard-data.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b9a9beb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b9a9beb', __exports__)) {
    api.reload('1b9a9beb', __exports__)
  }
  
  module.hot.accept("./clipboard-data.vue?vue&type=template&id=1b9a9beb", () => {
    api.rerender('1b9a9beb', render)
  })

}


export default __exports__